//static
export const LOCAL_STORAGE_SALT_KEY = "sevbaertg^&*%CDghuaft&%"
export const COMMONFILE_UPLOAD = "https://admin-api-prod.unibit-m.com";

// dev
// export const MODE = "DEV";
// export const API = "https://sourav.fun11.in:9014";
// export const SALT_KEY = "tuyadfgsg_dev";
// export const APP_ID = "ikduhgviouy_dev";

//prod
export const MODE = "PROD";
export const API = "https://admin-api.advy.me";
export const APP_ID = "3519818942646464_prod";
export const SALT_KEY = "564981189199810646_prod";